import { ErrorResponse, FgStatusEnum, OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { CommonResponse, PlantIdRequest, UnitTypeEnum } from "@gtpl/shared-models/masters";
import { CookingInventoryDto, LotCodeDropDown, LotCodeDropDownResponse, ProductionInventoryDetails } from "@gtpl/shared-models/production-management";
import appSettings from "apps/services/config";
import { length } from "class-validator";
import { EntityRepository, getManager, Repository } from "typeorm";
import { LotInfoRequest } from "../dto/lot-info.request";
import { LotNumberRequest } from "../dto/lot-number.request";
import { ProductionInventoryData } from "../dto/production-inventory.dto";
import { salordeIdandsoItemIdReq } from "../dto/so-and-soitem-request";
import { ProductionInventory } from "../entities/production-inventory.entity";

const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable = appSettings.sales_db + '.sale_order_items';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const productionLogTable = appSettings.production_db + '.production_log';
const productionInvTable = appSettings.production_db + '.production_inventory';
const workStationTable = appSettings.production_db + '.workstations';
@EntityRepository(ProductionInventory)
export class ProductionInventoryRepository extends Repository<ProductionInventory> {

  // async getLotNumbers(req: LotNumberRequest): Promise<LotCodeDropDown[]> {
  //   try {
  //     const lotCodes: LotCodeDropDown[] = await this.createQueryBuilder('production_inventory')
  //       .select('production_inventory.lot_number as lotNumber, sub_lot_number as subLotNumber')
  //       .where(`next_operation='${req.operation}' and plant_id=${req.plant} and physical_quantity - issued_quantity > 0`)
  //       .groupBy('lot_number')
  //       .getRawMany();
  //     return lotCodes
  //   } catch (error) {
  //     return error
  //   }
  // }

  async getLotNumbers(req: LotNumberRequest): Promise<LotCodeDropDown[]> {
    try {
      // const lotCodes: LotCodeDropDown[] = await this.createQueryBuilder('production_inventory')
      // .select('production_inventory.lot_number as lotNumber, sub_lot_number as subLotNumber')
      // .where(`next_operation='${req.operation}' and plant_id=${req.plant} and physical_quantity - issued_quantity > 0`)
      // .groupBy('lot_number')
      // .getRawMany();
      const manager = getManager();
      const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plant;
      const result =await manager.query(query);
      var lotCodeData = `SELECT CONCAT (production_inventory.sub_lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as sublotandplantlot,CONCAT (production_inventory.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,gi.remarks as plantLotNumber,production_inventory.lot_number as lotNumber, sub_lot_number as subLotNumber,plant_id as mainPlantId FROM ` +appSettings.production_db + `.production_inventory as production_inventory left join `+appSettings.rm_procure_db+`.grn_items gi on production_inventory.lot_number=gi.lot_number WHERE  `
      // if(req.operation == OperationTypeEnum.GRADING){
      //   lotCodeData += `next_operation='${OperationTypeEnum.BE_HEADING}' and physical_quantity - issued_quantity = 0 `
      // }else{
        lotCodeData += `next_operation='${req.operation}' and (physical_quantity - issued_quantity - conversion_quantity - rejected_quantity - stock_transfer_qty) > 0  `
      // }
      
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        lotCodeData += "AND production_inventory.sub_plant_id="+req.plant;
      }else{
        lotCodeData += "AND production_inventory.plant_id="+req.plant+' and production_inventory.sub_plant_id = 0';
      }
      lotCodeData += " group by sub_lot_number"
      const data =await manager.query(lotCodeData);
    return data
  } catch (error) {
    return error


    //   const manager =getManager();
    //   let query = 'SELECT p.lot_number AS lotNumber, p.sub_lot_number AS subLotNumber,CONCAT(p.sub_lot_number,"-",s.po_number,"-",m.brand_name) AS subLotNumber FROM '+ appSettings.production_db+'.production_inventory p LEFT JOIN '+ appSettings.sales_db +'.so_invoice_details s ON s.sale_order_id=p.sale_order_id LEFT JOIN '+ appSettings.sales_db +'.sale_order_items si ON si.sale_order_id=s.sale_order_id LEFT JOIN '+ appSettings.masters_db +'.master_brands m ON m.master_brand_id=si.brand_id  WHERE next_operation= "'+req.operation+'" AND plant_id='+req.plant+' AND physical_quantity-issued_quantity > 0 GROUP BY p.lot_number';
    //   const result: LotCodeDropDown[] = await manager.query(query)
    //   // if (result) {
    //     return result
    //   // } else {
    //   //   throw new ErrorResponse(9999, 'No Data Found');        
    //   // }
    // }
    // catch (err) {
    //   return err;
    }
  }

  async getSaleOrdersForLot(lotNoReq: LotInfoRequest) {
    try {
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+lotNoReq.plantId;
        const result =await manager.query(query);
        console.log('resultlll',query)
        let lotNoInformationQry = `select sale_order_id as saleOrderId,plant_id as plantId from ${appSettings.production_db}.production_inventory where sub_lot_number = '${lotNoReq.lotNumber}' and next_operation='${lotNoReq.presentOperation}' and physical_quantity - issued_quantity > 0`;
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          lotNoInformationQry += " AND production_inventory.sub_plant_id="+lotNoReq.plantId;
        }else{
          lotNoInformationQry += " AND production_inventory.plant_id="+lotNoReq.plantId;
        }
        const lotNoInformation = await manager.query(lotNoInformationQry)
      // const lotNoInformation = await this.createQueryBuilder('production_inventory')
      //   .select('sale_order_id as saleOrderId')
      //   .where(`sub_lot_number='${lotNoReq.lotNumber}' and next_operation='${lotNoReq.presentOperation}' and plant_id=${lotNoReq.plantId} and physical_quantity - issued_quantity > 0`)
      //   .getRawMany();
      return lotNoInformation
    } catch (error) {
      return error
    }
  }


  async getSaleOrderItemsForLotAndSo(lotNoReq: LotInfoRequest) {
    try {
      const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+lotNoReq.plantId;
        const result =await manager.query(query);
      // const lotNoInformation = await this.createQueryBuilder('production_inventory')
      //   .select('sale_order_item_id as saleOrderItemId')
      //   .where(`sub_lot_number='${lotNoReq.lotNumber}' and sale_order_id='${lotNoReq.saleOrderId}' and next_operation='${lotNoReq.presentOperation}' and plant_id=${lotNoReq.plantId} and physical_quantity - issued_quantity > 0`)
      //   .getRawMany();
      let lotNoInformationQry = `select sale_order_item_id as saleOrderItemId from ${appSettings.production_db}.production_inventory where sub_lot_number='${lotNoReq.lotNumber}' and sale_order_id='${lotNoReq.saleOrderId}' and next_operation='${lotNoReq.presentOperation}' and physical_quantity - issued_quantity > 0`;
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          lotNoInformationQry += " AND production_inventory.sub_plant_id="+lotNoReq.plantId;
        }else{
          lotNoInformationQry += " AND production_inventory.plant_id="+lotNoReq.plantId+' and production_inventory.sub_plant_id = 0';
        }
        const lotNoInformation = await manager.query(lotNoInformationQry)
      return lotNoInformation
    } catch (error) {
      return error
    }
  }

  async getLotNumberInfo(lotNoReq: LotInfoRequest) {
    try {
      const manager = getManager();
    
      const plantname='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+lotNoReq.plantId;
      const result =await manager.query(plantname);
      let lotNoInformation ='SELECT sub_lot_number as lotNumber,lot_number as lot, issued_quantity as issuedQuantity,sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId, input_grade as inputGrade, output_grade as outputGrade, boxes,transfered_boxes as transferredBoxes, (physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity) as availableQuantity, prod_inv_id as prodInvId, physical_quantity as physicalQuantity,  op_boxes as opBoxes,plant_id as mainPlantId FROM `production_inventory` `production_inventory` WHERE sub_lot_number="'+lotNoReq.lotNumber+'" and next_operation="'+lotNoReq.presentOperation+'"  and physical_quantity - issued_quantity > 0'
      console.log(result[0].plant_type)
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        lotNoInformation = lotNoInformation +' and sub_plant_id='+lotNoReq.plantId+' group by production_inventory.sale_order_item_id'
      }else{
        lotNoInformation = lotNoInformation +' and plant_id='+lotNoReq.plantId+' and sub_plant_id=0 group by production_inventory.sale_order_item_id'
      }
  const data = await manager.query(lotNoInformation)
        if(data.length > 0){
          return data
        }
    } catch (error) {
      return error
    }
  }

  // async getLotNumberInfo(lotNoReq: LotInfoRequest) {
  //   try {
  //     const lotNoInformation = await this.createQueryBuilder('production_inventory')
  //       .select('sub_lot_number as lotNumber,lot_number as lot, issued_quantity as issuedQuantity,sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId, input_grade as inputGrade, output_grade as outputGrade, boxes, (physical_quantity-issued_quantity) as availableQuantity, prod_inv_id as prodInvId, physical_quantity as physicalQuantity,  op_boxes as opBoxes')
  //       .where(`sub_lot_number='${lotNoReq.lotNumber}' and next_operation='${lotNoReq.presentOperation}' and plant_id=${lotNoReq.plantId} and physical_quantity - issued_quantity > 0`)
  //       .getRawOne();
  //     return lotNoInformation
  //   } catch (error) {
  //     return error
  //   }
  // }
  async getLotInformation(lotNoReq: LotInfoRequest) {
    console.log('hhhhhhhhhhhhh' + lotNoReq.presentOperation);
    let operation = lotNoReq.presentOperation;
    try {
      const lotNoInformation = await this.createQueryBuilder('production_inventory')
        .select('lot_number as lotNumber, physical_quantity as physicalQuantity, issued_quantity as issuedQuantity, operation as Operation,production_log.job_number as jobNumber,production_log.workstation as workstation, production_log.job_status as jobStatus, production_log.assigned_time as assignedTime')
        .leftJoin('production_log', 'productionLog', 'productionLog. = SaleOrder.sale_order_id')

        .leftJoin('production_inventory.production_log', 'productionLog')
        // .leftJoin('production_inventory.production_log.workstation', 'workstation')
        .where(`sub_lot_number='${lotNoReq.lotNumber}' and operation ='${operation}' and plant_id=${lotNoReq.plantId}`)
        .getRawMany();
      return lotNoInformation
    } catch (error) {
      return error
    }
  }


  async getLotNumberInfoForBeheading(lotNoReq: LotInfoRequest) {
    try {
      const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+lotNoReq.plantId;
        const result =await manager.query(query);
      // const lotNoInformation = await this.createQueryBuilder('production_inventory')
      //   .select('sub_lot_number as lotNumber, issued_quantity as issuedQuantity,sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId, input_grade as inputGrade, output_grade as outputGrade, boxes, (physical_quantity-issued_quantity) as availableQuantity, prod_inv_id as prodInvId, physical_quantity as physicalQuantity,  op_boxes as opBoxes')
      //   .where(`sub_lot_number='${lotNoReq.lotNumber}' and sale_order_id ='${lotNoReq.saleOrderId}' and sale_order_item_id ='${lotNoReq.saleOrderItemId}'  and next_operation='${lotNoReq.presentOperation}' and plant_id=${lotNoReq.plantId} and physical_quantity - issued_quantity > 0`)
      //   .getRawOne();
      let lotNoInformationQry = `select sub_lot_number as lotNumber, issued_quantity as issuedQuantity,sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId, input_grade as inputGrade, output_grade as outputGrade, boxes, (physical_quantity-issued_quantity) as availableQuantity, prod_inv_id as prodInvId, physical_quantity as physicalQuantity,op_boxes as opBoxes from ${appSettings.production_db}.production_inventory where sub_lot_number='${lotNoReq.lotNumber}' and sale_order_id ='${lotNoReq.saleOrderId}' and sale_order_item_id ='${lotNoReq.saleOrderItemId}' and next_operation='${lotNoReq.presentOperation}' and physical_quantity - issued_quantity > 0`;
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        lotNoInformationQry += " AND production_inventory.sub_plant_id="+lotNoReq.plantId;
      }else{
        lotNoInformationQry += " AND production_inventory.plant_id="+lotNoReq.plantId+' and production_inventory.sub_plant_id = 0';
      }
      const lotNoInformation =await manager.query(lotNoInformationQry);
      return lotNoInformation[0]
    } catch (error) {
      return error
    }
  }

  async updateInventoryQuantity(inputReq: ProductionInventoryData,columnName:string): Promise<boolean> {
    try {
      console.log(inputReq);
      console.log(columnName);

      let updatedInventory
      if(columnName == 'plantId'){
        updatedInventory = await this.update({ lotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, plantId: inputReq.plantId,subPlantId: 0 }, { wipQuantity: () => `wip_quantity+${inputReq.wipQuantity}`, boxes: () => `boxes+${inputReq.ipBoxes}` })
      }
      if(columnName == 'subPlantId'){
        updatedInventory = await this.update({ lotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, subPlantId: inputReq.plantId }, { wipQuantity: () => `wip_quantity+${inputReq.wipQuantity}`, boxes: () => `boxes+${inputReq.ipBoxes}` })
      }
      console.log(updatedInventory);
      if (updatedInventory.affected) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false
    }
  }

  async updateInventoryIssuedQuantity(lotNumber: string, subLotNumber: string, saleOrderId: number, saleOrderItemId: number, productionInventoryId: number, plantId: number, physicalQuantity: number): Promise<boolean> {
    try {
      const manager = getManager();
      const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
      const result =await manager.query(query);
      let updatedInventory   
      if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
        updatedInventory = await this.update({lotNumber:lotNumber, subLotNumber: subLotNumber, saleOrderId: saleOrderId, saleOrderItemId: saleOrderItemId, productionInventoryId: productionInventoryId, subPlantId: plantId }, { issuedQuantity: () => `issued_quantity+${physicalQuantity}` });
      }else{
        updatedInventory = await this.update({lotNumber:lotNumber, subLotNumber: subLotNumber, saleOrderId: saleOrderId, saleOrderItemId: saleOrderItemId, productionInventoryId: productionInventoryId, plantId: plantId ,subPlantId:0}, { issuedQuantity: () => `issued_quantity+${physicalQuantity}` });
      }
   
      if (updatedInventory.affected) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false
    }
  }
  async updateInventoryAssignRejectedQuantity(lotNumber: string, subLotNumber: string, productionInventoryId: number, physicalQuantity: number): Promise<boolean> {
    try {
      const updatedInventory = await this.update({ lotNumber: lotNumber, subLotNumber: subLotNumber, productionInventoryId: productionInventoryId }, { assignedRejection: () => `assigned_rejection+${physicalQuantity}` });
      if (updatedInventory.affected) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return error
    }
  }

  async updateInventoryPhysicalQuantity(jobCompletedInputQty: number, jobCompletedOutputQty: number, jobCompletedWastageQty: number, nextOperation: OperationTypeEnum, inputReq?: ProductionInventoryData,columnName?:string): Promise<boolean> {
    console.log("inputReq***********");
    console.log(inputReq);

    try {
      let updatedInventory
      if(columnName == 'plantId'){

      // update previous qty
        updatedInventory = await this.update({ lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, plantId: inputReq.plantId,subPlantId:0 }, { wipQuantity: () => `wip_quantity-${jobCompletedInputQty}`, physicalQuantity: () => `physical_quantity+${jobCompletedOutputQty}`, wastageQuantity: () => `wastage_quantity+${jobCompletedWastageQty}`, nextOperation: nextOperation, opBoxes: () => `op_boxes+${inputReq.opBoxes}` })
      }
      if(columnName == 'subPlantId'){
        updatedInventory = await this.update({ lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, subPlantId: inputReq.subPlantId }, { wipQuantity: () => `wip_quantity-${jobCompletedInputQty}`, physicalQuantity: () => `physical_quantity+${jobCompletedOutputQty}`, wastageQuantity: () => `wastage_quantity+${jobCompletedWastageQty}`, nextOperation: nextOperation, opBoxes: () => `op_boxes+${inputReq.opBoxes}` })
      }
      console.log(columnName);
      console.log(updatedInventory);
      // const updatedInventory = await this.update({productionInventoryId:9}, {wipQuantity: ()=>`wip_quantity-${jobCompletedInputQty}`, physicalQuantity:()=>`physical_quantity+${jobCompletedOutputQty}`, wastageQuantity:()=>`wastage_quantity+${jobCompletedWastageQty}`,nextOperation:nextOperation, opBoxes: () => `op_boxes+${inputReq.opBoxes}`})

      if (updatedInventory.affected) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false
    }
  }

  async updateInventoryPhysicalIntransitQuantity(jobCompletedInputQty: number, jobCompletedOutputQty: number, jobCompletedWastageQty: number, nextOperation: OperationTypeEnum, inputReq?: ProductionInventoryData): Promise<boolean> {
    try {
      // update previous qty
      const updatedInventory = await this.update({ lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, plantId: inputReq.plantId }, { intransitQuantity: () => `intransit_quantity-${jobCompletedOutputQty}`, physicalQuantity: () => `physical_quantity+${jobCompletedOutputQty}`, nextOperation: nextOperation, rejectedQuantity: () => `rejected_quantity+${inputReq.rejectedQuantity}`, opBoxes: () => `op_boxes+${inputReq.opBoxes}` })

      if (updatedInventory.affected) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false
    }
  }
  async updateInventoryOutPutGrade(lotNumber: string, outputGrade: number, workStation: number, outputQuantity: number, nextOperation: OperationTypeEnum,inputQuantity:number): Promise<boolean> {
    try {
      const updatedInventory = await this.update({ subLotNumber: lotNumber, operation: OperationTypeEnum.SOAKING }, { nextOperation: nextOperation, outputGrade: outputGrade, physicalQuantity: () => `physical_quantity+${outputQuantity}`, wipQuantity: () => `wip_quantity-${inputQuantity}` })
      console.log(updatedInventory);
      if (updatedInventory.affected) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return error
    }
  }

  async getInventoryData(operation: OperationTypeEnum, plantId: number) {
    try {
      const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
      // const prodInvData = await this.createQueryBuilder('production_inventory')
      //   .select('production_inventory.lot_number as lotNumber,group_concat(distinct(lot_number)) as lotNumbers,sub_lot_number as subLotNumber,sum(physical_quantity) as totalReportedQty')
      //   .where(`operation='${operation}' and plant_id=${plantId}`)
      //   .getRawOne();
      // console.log(prodInvData);
      let prodInvData = `select count(distinct(lot_number)) AS totalLots,production_inventory.lot_number as lotNumber,group_concat(distinct(lot_number)) as lotNumbers,sub_lot_number as subLotNumber,sum(physical_quantity) as totalReportedQty from ${appSettings.production_db}.production_inventory where next_operation='${operation}'`;
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        prodInvData += " AND production_inventory.sub_plant_id="+plantId;
      }else{
        prodInvData += " AND production_inventory.plant_id="+plantId+' and production_inventory.sub_plant_id = 0';
      }
      const prodInformation =await manager.query(prodInvData);
      if (prodInformation.length > 0) {
        return prodInformation
      } else {
        return null
      }
    } catch (error) {
      return error
    }
  }

  async gettoBeProcessedData(operation: OperationTypeEnum, plantId: number) {
    try {
      const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
      // const prodInvReportedData = await this.createQueryBuilder('production_inventory')
      //   .select('count(lot_number) as noOfLots , sum(issued_quantity) as processedQty,sum(physical_quantity-issued_quantity) as totalReportedQty')
      //   .where(`next_operation='${operation}' and plant_id=${plantId}`)
      //   .getRawOne();
      let prodInvReportedData = `SELECT count(lot_number) as noOfLots , sum(issued_quantity) as processedQty,sum(physical_quantity-issued_quantity) as totalReportedQty from ${appSettings.production_db}.production_inventory where next_operation='${operation}'`;
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        prodInvReportedData += " AND production_inventory.sub_plant_id="+plantId;
      }else{
        prodInvReportedData += " AND production_inventory.plant_id="+plantId+' and production_inventory.sub_plant_id = 0';
      }
      const prodInvoReportedData =await manager.query(prodInvReportedData);
      if (prodInvoReportedData.length > 0) {
        return prodInvoReportedData
      } else {
        return null
      }
    } catch (error) {
      return error
    }
  }

  async updateIssuedQty(plantId: number, nextOperation: OperationTypeEnum, lotNumber: string, subLotNumber: string, soId: number, soItemId: number, issuedQty: number,columnName:string): Promise<boolean> {
    try {
      //need to rename reported_qty as issuedqty after entity change
      let updateQty
      if(columnName == 'plantId'){
        updateQty = await this.update({ plantId: plantId, nextOperation: nextOperation, subLotNumber: subLotNumber, saleOrderId: soId, saleOrderItemId: soItemId,subPlantId:0 }, { issuedQuantity: () => `issued_quantity+${issuedQty}` })
      }
      if(columnName == 'subPlantId'){
        updateQty = await this.update({ nextOperation: nextOperation, subLotNumber: subLotNumber, saleOrderId: soId, saleOrderItemId: soItemId,subPlantId:plantId }, { issuedQuantity: () => `issued_quantity+${issuedQty}` })
      }
      console.log(updateQty);
      if (updateQty.affected) {
        return true
      } else {
        return false
      }
    } catch (err) {
      return err;
    }
  }

  async getAllInventoryData(operation: OperationTypeEnum, plantId: number) {
    try {
      const prodInvData = await this.createQueryBuilder('production_inventory')
        .where(`next_operation='${operation}' and plant_id=${plantId} and physical_quantity - issued_quantity > 0`)
        .getMany();
      if (prodInvData) {
        return prodInvData
      } else {
        return null
      }
    } catch (error) {
      return error
    }
  }

  async getAllAvailableInventoryData(operation: OperationTypeEnum, plantId: number) {
    try {
      const manager = getManager();
      // const prodInvData = await this.createQueryBuilder('production_inventory')
      //   .where(`next_operation='${operation}' and plant_id=${plantId} and physical_quantity > issued_quantity`)
      //   .getMany();
      const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var prodInvData = `SELECT *  FROM ` + appSettings.production_db + `.production_inventory WHERE next_operation='${operation}' and plant_id=${plantId} and physical_quantity > issued_quantity ` 
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          prodInvData += "AND sub_plant_id="+plantId;
        }else{
          prodInvData += "AND plant_id="+plantId+' and sub_plant_id = 0';
        }
        const data =await manager.query(prodInvData);
      if (data) {
        return data
      } else {
        return null
      }
    } catch (error) {
      return error
    }
  }

  async getNoOfAvailableBoxes(operation: OperationTypeEnum, plantId: number): Promise<number> {
    try {
      const manager = getManager();
      // const noOfRecords = await this.createQueryBuilder('production_inventory')
      //   .select('count(*) as noOfRecords')
      //   .where(`next_operation='${operation}' and plant_id=${plantId} and status!="${FgStatusEnum.CLOSE}" and physical_quantity>0`)
      //   .getRawOne();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var noOfRecordsquery = `SELECT count(*) as noOfRecords FROM ` + appSettings.production_db + `.production_inventory WHERE next_operation='${operation}' and status!="${FgStatusEnum.CLOSE}" and (physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity)>0 ` 
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          noOfRecordsquery += "AND sub_plant_id="+plantId;
        }else{
          if(plantId && plantId!=5){
            noOfRecordsquery += "AND plant_id="+plantId+' and sub_plant_id = 0';
          }
         else{
          noOfRecordsquery += ' and sub_plant_id = 0';
         }
        }
        const data =await manager.query(noOfRecordsquery);
      if (data) {
        return data;
      } else {
        return 0
      }
    } catch (error) {
      return error
    }
  }

  async getQtyToBeProcessed(operation: OperationTypeEnum, plantId: number): Promise<number> {
    try {
      // const qty = await this.createQueryBuilder('production_inventory')
      //   .select('sum(physical_quantity-issued_quantity) as qty')
      //   .where(`next_operation='${operation}' and plant_id=${plantId} and status!="${FgStatusEnum.CLOSE}"`)
      //   .getRawOne();
      const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var qtyQyery = `SELECT sum(physical_quantity-issued_quantity) as qty FROM ` + appSettings.production_db + `.production_inventory WHERE next_operation='${operation}' and status!="${FgStatusEnum.CLOSE}" and (physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity) > 0 ` 
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          qtyQyery += "AND sub_plant_id="+plantId;
        }else{
          if(plantId && plantId!=5){
            qtyQyery += "AND plant_id="+plantId+' and sub_plant_id = 0';
          }
          else{
            qtyQyery += ' and sub_plant_id = 0';
          }
         
        }
        const data =await manager.query(qtyQyery);
      if (data) {
        return data;
      } else {
        return 0
      }
    } catch (error) {
      return error
    }
  }

  async getInventoryQty(operation: OperationTypeEnum, plantId: number): Promise<number> {
    try {
      // const qty = await this.createQueryBuilder('production_inventory')
      //   .select('sum(physical_quantity) as qty')
      //   .where(`operation='${operation}' and plant_id=${plantId} and status!="${FgStatusEnum.CLOSE}"`)
      //   .getRawOne();
      const manager = getManager();
      const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
      const result =await manager.query(query);
      var qtyQyery = `SELECT sum(physical_quantity-issued_quantity) as qty FROM ` + appSettings.production_db + `.production_inventory WHERE operation='${operation}' and status!="${FgStatusEnum.CLOSE}" and physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity>0 ` 
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        qtyQyery += "AND sub_plant_id="+plantId;
      }else{
        if(plantId && plantId!=5){
          qtyQyery += "AND plant_id="+plantId+' and sub_plant_id = 0';
        }
        else{
          qtyQyery += ' and sub_plant_id = 0';
        }
        
      }
      const data =await manager.query(qtyQyery);
    if (data) {
      return data;
      } else {
        return 0
      }
    } catch (error) {
      return error
    }
  }

  async getInventoryInfo(operation: OperationTypeEnum, plantId: number): Promise<ProductionInventoryDetails[]> {
    try {
      // const response: ProductionInventoryDetails[] = await this.createQueryBuilder('production_inventory')
      //   .select('lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId ,round(issued_quantity) as issuedQuantity, round(physical_quantity) as physicalQuantity, round(intransit_quantity) as intransitQuantity, round(wip_quantity) as wipQuantity, round(wastage_quantity) as wastageQuantity, round(rejected_quantity) as rejectedQuantity, boxes as boxes, input_grade as inputGrade, output_grade as outputGrade, operation, op_boxes as opBoxes, prod_inv_id as productionInventoryId, next_operation as nextOperation, output_grade as count')
      //   .where(`operation="${operation}" and plant_id=${plantId} and status!="${FgStatusEnum.CLOSE}"`)
      //   .getRawMany();
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var resQuery = `SELECT lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId ,round(issued_quantity) as issuedQuantity, round(physical_quantity) as physicalQuantity, round(intransit_quantity) as intransitQuantity, round(wip_quantity) as wipQuantity, round(wastage_quantity) as wastageQuantity, round(rejected_quantity) as rejectedQuantity, boxes as boxes, input_grade as inputGrade, output_grade as outputGrade, operation, op_boxes as opBoxes, prod_inv_id as productionInventoryId, next_operation as nextOperation, output_grade as count FROM `+ appSettings.production_db+`.production_inventory WHERE operation="${operation}" and status!="${FgStatusEnum.CLOSE}"`
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          resQuery += "AND sub_plant_id="+plantId;
        }else{
          resQuery += "AND plant_id="+plantId+' and sub_plant_id = 0';
        }
        const response =await manager.query(resQuery);
      if (response) {
        return response;
      } else {
        return []
      }
    } catch (error) {
      return error
    }
  }

  async getInventoryWipData() {
    try {
      const prodInvData = await this.createQueryBuilder('production_inventory')
        .select('sale_order_item_id,sale_order_id,sum(wip_quantity) as wipQty')
        .groupBy('sale_order_item_id')
        .getRawMany();
      if (prodInvData) {
        return prodInvData
      } else {
        return null
      }
    } catch (error) {
      return error
    }
  }
  async getLotCodesData(req: PlantIdRequest) {
    try {
      const prodInvData = await this.createQueryBuilder('production_inventory')
        .where('plant_id =' + req.unitcodeId)
        .groupBy('lot_number')
        .getMany();
      if (prodInvData) {
        return prodInvData
      } else {
        return null
      }
    } catch (error) {
      return error
    }
  }


  async getCookingInventory(plantId: number): Promise<CookingInventoryDto[]> {
    try {
      const manager = getManager();
      const query = `SELECT prod_inv_id as productionInventoryId, lot_number as lotNumber, inv.sale_order_id as saleOrderId, so.sale_order_no as soNumber, sc.variant_code as variantCode, issued_quantity as inputQuantity, inv.plant_id plantId, inv.created_user createdUser, inv.sale_order_item_id as saleOrderItemId, operation as operationType, next_operation as nextOperation, inv.status, physical_quantity as physicalQuantity FROM ` + productionInvTable + ` inv 
            LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=inv.sale_order_id
            LEFT JOIN `+ salesSoItemTable + ` soi ON soi.sale_order_item_id=inv.sale_order_item_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
            where  inv.operation='${OperationTypeEnum.COOKING}' and inv.plant_id=${plantId}`;

      const response: CookingInventoryDto[] = await manager.query(query);

      return response;
    } catch (error) {
      return error;
    }
  }


  async getReadyForCookingInventory(plantId: number): Promise<CookingInventoryDto[]> {
    try {
      const manager = getManager();
      const uquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
      const result =await manager.query(uquery);
      let query = `SELECT prod_inv_id as productionInventoryId, lot_number as lotNumber, inv.sale_order_id as saleOrderId, so.sale_order_no as soNumber, sc.variant_code as variantCode, issued_quantity as inputQuantity, inv.plant_id plantId, inv.created_user createdUser, inv.sale_order_item_id as saleOrderItemId, operation as operationType, next_operation as nextOperation, inv.status,si.po_number as poNumber, physical_quantity as physicalQuantity FROM ` + productionInvTable + ` inv 
            LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=inv.sale_order_id
            LEFT JOIN `+ salesSoItemTable + ` soi ON soi.sale_order_item_id=inv.sale_order_item_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
            LEFT JOIN `+ salesInvTable + ` si ON si.sale_order_id=inv.sale_order_id
            where  inv.next_operation='${OperationTypeEnum.COOKING}'`
            if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
              query += "AND inv.sub_plant_id="+plantId;
            }else{
              query += "AND inv.plant_id="+plantId+' and inv.sub_plant_id = 0';
            }

      const response: CookingInventoryDto[] = await manager.query(query);
      console.log(response)

      return response;
    } catch (error) {
      return error;
    }
  }

  async getWipQuantityAgainstsoandsoitem(req:salordeIdandsoItemIdReq):Promise<CommonResponse>{
    try{
      const manager = getManager();
     const query='SELECT wip_quantity FROM '+appSettings.production_db+'.`production_inventory` WHERE sale_order_id = '+req.saleOrderId+' AND sale_order_item_id='+req.saleOrderItemId+''
     const response= await manager.query(query);
     console.log(response)
     return response;
    }catch(err){
      return err
    }
  }


}